<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showBranch") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.desc')"
            v-model.trim="data.descProd"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.descProdEn"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.location"
            disabled
          />
          <!-- End:: Name Input -->

          <div class="map_wrapper">
            <GmapMap
              :center="center"
              :zoom="7"
              map-type-id="terrain"
              style="width: 100%; height: 500px"
              @click="mapOptions"
            >
              <GmapMarker
                :position="marker.position"
                :clickable="false"
                :draggable="false"
              />
            </GmapMap>

            <!-- <GmapMap
                    :center="center"
                    :zoom="7"
                    map-type-id="terrain"
                    style="width: 100%; height: 360px"
                    @click="handleMapClick"
                  >
                    <GmapMarker
                      :position="marker.position"
                      :clickable="true"
                      :draggable="true"
                      @click="markerClicked"
                      @dragend="markerDragged($event)"
                    />
                  </GmapMap> -->
          </div>

          <v-container>
            <v-row v-for="(box, index) in boxes" :key="index" align="center">
              <!-- <v-col cols="12" class="text-right">
                <v-btn icon color="primary" @click="addBox">
                  <i class="fas fa-plus"></i>
                </v-btn>

                <v-btn
                  icon
                  color="red"
                  v-if="boxes.length > 1"
                  @click="removeBox(index)"
                >
                  <i class="fas fa-minus"></i>
                </v-btn>
              </v-col> -->
              <base-select-input
                col="4"
                :optionsList="weekdays_selection"
                :placeholder="$t('PLACEHOLDERS.day')"
                v-model="box.day"
                disabled
              />
              <base-input
                col="4"
                type="time"
                :placeholder="$t('PLACEHOLDERS.from')"
                v-model="box.from"
                disabled
              />
              <base-input
                col="4"
                type="time"
                :placeholder="$t('PLACEHOLDERS.to')"
                v-model="box.to"
                disabled
              />
              <v-divider class="my-4"></v-divider>
            </v-row>
          </v-container>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowProduct",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",
      center: { lat: 24.7136, lng: 46.6753 },
      zoom: 10,
      currentPlace: null,
      markers: [],
      marker: {
        position: { lat: 24.7136, lng: 46.6753 },
      },

      Latitude: "",
      Longitude: "",
      Radius: "",
      place: "",
      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        location: null,
        quantity: null,
        expire_date_from: null,
        expire_date_to: null,
        section: null,
        pranches: null,
        active: null,
      },
      boxes: [
        {
          day: "",
          from: "",
          to: "",
        },
      ],
      // End:: Data Collection To Send
      pranches: [],
      categories: [],
      subCats: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
    weekdays_selection() {
      return [
        { id: 1, name: this.$t("PLACEHOLDERS.sunday"), value: "sunday" },
        { id: 2, name: this.$t("PLACEHOLDERS.monday"), value: "monday" },
        { id: 3, name: this.$t("PLACEHOLDERS.tuesday"), value: "tuesday" },
        { id: 4, name: this.$t("PLACEHOLDERS.wednesday"), value: "wednesday" },
        { id: 5, name: this.$t("PLACEHOLDERS.thursday"), value: "thursday" },
        { id: 6, name: this.$t("PLACEHOLDERS.friday"), value: "friday" },
        { id: 7, name: this.$t("PLACEHOLDERS.saturday"), value: "saturday" },
      ];
    },
  },

  methods: {
    handleMapClick(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      const radius = this.calculateDistance(
        lat,
        lng,
        this.center.lat,
        this.center.lng
      );

      const geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(lat, lng);

      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.Latitude = lat;
          this.Longitude = lng;
          this.Radius = radius;
          this.place = results[0].formatted_address;

          console.log("Latitude:", lat);
          console.log("Longitude:", lng);
          console.log("Radius:", radius);
          console.log("Place:", results[0].formatted_address);

          this.marker.position = { lat, lng }; // Update the marker's position
        }
      });
    },

    calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 6371; // Radius of the earth in kilometers
      const dLat = this.deg2rad(lat2 - lat1);
      const dLng = this.deg2rad(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLng / 2) *
          Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c * 1000; // Convert to meters
      return distance;
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    handleMarkerClick(index) {
      console.log("Marker clicked:", index);
    },

    markerClicked() {
      // Handle marker click event
      const lat = this.marker.position.lat;
      const lng = this.marker.position.lng;
      const radius = this.calculateDistance(
        lat,
        lng,
        this.center.lat,
        this.center.lng
      );
      console.log("Marker clicked:", lat, lng);
      console.log(radius);
    },

    async markerDragged(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      const radius = this.calculateDistance(
        lat,
        lng,
        this.center.lat,
        this.center.lng
      );

      try {
        const geocoder = new google.maps.Geocoder();
        const latLng = new google.maps.LatLng(lat, lng);
        const results = await this.reverseGeocode(lat, lng, geocoder);

        if (results.length > 0) {
          this.Latitude = lat;
          this.Longitude = lng;
          this.Radius = radius;
          this.place = results[0].formatted_address;

          console.log("Latitude:", lat);
          console.log("Longitude:", lng);
          console.log("Radius:", radius);
          console.log("Place:", results[0].formatted_address);

          this.marker.position = { lat, lng }; // Update the marker's position
        }
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    },

    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },

    addMarker() {
      if (
        this.currentPlace &&
        this.currentPlace.geometry &&
        this.currentPlace.geometry.location
      ) {
        this.marker.position.lat = this.currentPlace.geometry.location.lat();
        this.marker.position.lng = this.currentPlace.geometry.location.lng();

        this.Latitude = this.currentPlace.geometry.location.lat();
        this.Longitude = this.currentPlace.geometry.location.lng();

        this.center.lat = this.currentPlace.geometry.location.lat();
        this.center.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },

    reverseGeocode(lat, lng, geocoder) {
      return new Promise((resolve, reject) => {
        const latLng = new google.maps.LatLng(lat, lng);
        geocoder.geocode({ location: latLng }, (results, status) => {
          if (status === "OK") {
            resolve(results);
          } else {
            reject(new Error("Geocoder failed"));
          }
        });
      });
    },
    addBox() {
      this.boxes.push({
        day: "",
        from: "",
        to: "",
      });
    },
    removeBox(index) {
      if (this.boxes.length > 1) {
        this.boxes.splice(index, 1);
      }
    },
    async getCats() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories?page=0&limit=0`,
        });
        // console.log("products =>", res.data.data);
        this.categories = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getPranches() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `branches?page=0&limit=0`,
        });
        // console.log("products =>", res.data.data);
        this.pranches = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    // start show data
    async showProduct() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `branches/${this.$route.params.id}`,
        });
        this.data.name = res.data.data.Branch.name_ar;
        this.data.nameEn = res.data.data.Branch.name_en;
        this.data.descProd = res.data.data.Branch.description_ar;
        this.data.descProdEn = res.data.data.Branch.description_en;
        this.data.location = res.data.data.Branch.location;
        this.Latitude = res.data.data.Branch.latitude;
        this.Longitude = res.data.data.Branch.longitude;
        this.center.lat = parseFloat(res.data.data.Branch.latitude);
        this.center.lng = parseFloat(res.data.data.Branch.longitude);
        this.marker.position.lat = parseFloat(res.data.data.Branch.latitude);
        this.marker.position.lng = parseFloat(res.data.data.Branch.longitude);
        this.boxes = res.data.data.Branch.opening_hours?.map((ele) => ({
          day: {
            id: 1,
            name: this.$t(`PLACEHOLDERS.${ele.day}`),
            value: ele.day,
          },
          from: ele.from,
          to: ele.to,
        }));
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    // Start:: Fire Methods
    this.showProduct();
    this.getCats();
    this.getPranches();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
}
</style>
